<form class="main-content" [formGroup]="form">
    <span class="title">
        {{ 'INCIDENT_RECORD' | translate }}
    </span>
    <span *ngIf="mode == FORM_MODAL" class="close-btn" (click)="closeModal(false)">
    </span>
    <div class="main-content--scroll">
        <span class="img-video-container">
            <img data-clarity-mask="true" [attr.src]="image" *ngIf="isImage == true && image != undefined" class="img-video" >
            <video data-clarity-mask="true"  class="img-video" *ngIf="isImage == false && image != undefined" width="100%" height="100%" id="video" type="video/mp4" autoplay loop [src]="image">
            </video>
            <span class="img-expand" (click)="openCarousel()" *ngIf="mode == FORM_MODAL && showCarrousel == true"></span>
        </span>
        <div class="move-controls">
            <span class="move-control move-left" (click)="moveLeft()" >
                <mat-icon>arrow_back</mat-icon>
            </span>
            <span class="move-control move-right" (click)="moveRight()" >
                <mat-icon>arrow_forward</mat-icon>
            </span>
        </div>
        <div class="form-controls">
            <div class="field safety-items--field">
                <mat-label>{{ "safetyItems" | translate }}</mat-label>
                <div class="safety-items--container">
                    <span class="safety-items--item" *ngFor="let item of form.controls.SafetyItems.value"
                    [ngStyle]="{
                        'background-image': 'url(' + item.icon + ')'
                    }">
                    </span>
                </div>
            </div>


            <div class="field" *ngIf="EmbeddingPromptResponseVisible == true"  [ngClass]="{ 'field-embed-mode':  mode == FORM_EMBED}">
                <mat-label>{{ "embbedingPromptResponse" | translate }}</mat-label>
                <mat-form-field appearance="outline">
                    <textarea formControlName="EmbeddingPromptResponse" matInput rows="5" tabindex="-1"></textarea>
                </mat-form-field>
            </div>

            <div class="field" [ngClass]="{ 'field-embed-mode':  mode == FORM_EMBED}">
                <mat-label>{{ "eventDescription" | translate }}</mat-label>
                <mat-form-field appearance="outline">
                    <textarea formControlName="Event" matInput rows="3" tabindex="-1"></textarea>
                </mat-form-field>
            </div>
            <div class="field" [ngClass]="{ 'field-embed-mode':  mode == FORM_EMBED}">
                <mat-label>{{ "occurred" | translate }}</mat-label>
                <mat-form-field appearance="outline">
                    <input formControlName="Date" matInput tabindex="-1">
                </mat-form-field>
            </div>
            <div class="field" [ngClass]="{ 'field-embed-mode':  mode == FORM_EMBED}">
                <mat-label>{{ "site" | translate }}</mat-label>
                <mat-form-field appearance="outline">
                    <input formControlName="Site" matInput tabindex="-1">
                </mat-form-field>
            </div>
            <div class="field" [ngClass]="{ 'field-embed-mode':  mode == FORM_EMBED}">
                <mat-label>{{ "incidentArea" | translate }}</mat-label>
                <mat-form-field appearance="outline">
                    <input formControlName="Location" matInput tabindex="-1">
                </mat-form-field>
            </div>
            <div class="field" [ngClass]="{ 'field-embed-mode':  mode == FORM_EMBED}">
                <mat-label>{{ "incidentType" | translate }}</mat-label>
                <mat-form-field appearance="outline">
                    <input formControlName="Type"  matInput tabindex="-1">
                </mat-form-field>
            </div>
            <div class="field" [ngClass]="{ 'field-embed-mode':  mode == FORM_EMBED}">
                <mat-label>{{ "ACTIONS_TAKEN" | translate }}</mat-label>
                <mat-form-field  appearance="outline">
                    <textarea formControlName="ActionsTaken" matInput rows="3" tabindex="-1"></textarea>
                </mat-form-field>
            </div>
            <div class="field" [ngClass]="{ 'field-embed-mode':  mode == FORM_EMBED}">
                <mat-label>{{ "RESPONSIBLE" | translate }}</mat-label>
                <mat-form-field appearance="outline">
                    <input formControlName="Responsible" matInput tabindex="-1">
                    <mat-error *ngIf="form.controls['Responsible'].hasError('maxLength')" >Email is <strong>required</strong></mat-error>
                </mat-form-field>
            </div>
            <div class="field" [ngClass]="{ 'field-embed-mode':  mode == FORM_EMBED}">
                <mat-label>{{ 'DUE_DATE' | translate }}</mat-label>
                <mat-form-field appearance="outline">
                    <input type="date" matInput formControlName="DueDate" tabindex="-1" >
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="buttons" *ngIf="mode == FORM_MODAL">
        <div class="buttons-sub-container">
                <button *ngIf="disableButtons == false"  mat-button class="button reject-button" (click)="showRejectIncident()" >
                    {{ "REJECT" | translate }}
                </button>
                <button mat-flat-button color="primary" *ngIf="disableButtons == false" class="button accept-button" (click)="acceptIncident()"> 
                    <span class="confirm-ico-btn"></span> 
                    {{ 'ACCEPT' | translate }}
                </button>
                <button *ngIf="disableButtons == false" mat-button class="button continue-button" (click)="continueButton()" >
                    <span class="continue-ico-btn"></span> 
                    {{ "CONTINUE" | translate }}
                </button>
        </div>
    </div> 
</form>